import type { FaireProductEntity } from "../../entity_types/product";

export const p_6kgfgv94cf: FaireProductEntity = {
  token: "p_6kgfgv94cf",
  type: "product",
  name: "Necco Original Candy Wafers Rolls 24/2OZ",
  brandToken: "b_ktcqb4hfg7",
  brandName: "L&F Universal Goods",
  imageUrl:
    "https://cdn.faire.com/fastly/92c2f926c820cdcada0de41fd19ab8edf818059b94a77847f12263f46499892b.jpeg",
  galleryImageUrls: [],
  priceDollars: 72.06,
  description:
    "Original Necco wafers; classic candy rolls ideal for bulk candy assortments.",
  tags: [],
  msrpDollars: 142.73,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:48:47.748Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
